// Mapping route -> alias utilisés dans project.datavizTabs / project.settingTabs
export const ROUTES_ALIASES: Record<string, string[]> = {
  'dashboard': ['dashboard'],
  'viewer/forge': ['forge', 'viewer/forge'],
  'viewer/maps': ['maps', 'viewer/maps'],
  'plannings': ['planning', 'plannings'],
  'report': ['report', 'timeline', 'events'],
  'risks': ['risks', 'risk'],
  'actions': ['actions', 'action'],
  'timelapse': ['enlaps', 'timelapse', 'timelapseGo'],
  'stream': ['stream', 'hse'],
  'informations': ['info'],
  'models': ['models'],
  'workflows': ['workflows', 'flow'],
  'project-settings/users': ['users'],
  'project-settings/resources': ['resources', 'resource'],
  'project-settings/security': ['privacy'],
  'project-settings/tags': ['tag'],
  'project-settings/database': ['exportdb'],
  'project-settings/kyd': ['kyd']
};

export function isRouteAllowed(route: string, allowedTabs: string[]): boolean {
  for (const [realRoute, aliases] of Object.entries(ROUTES_ALIASES)) {
    if (route.includes(realRoute)) {
      return aliases.some(alias => allowedTabs.includes(alias));
    }
  }

  return false;
}
